var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "26px",
    viewBox: "0 0 34 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 42") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header",
    transform: "translate(-1317.000000, -51.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 43.000000)",
    id: "Group-42"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1317.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shopping-bag",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9958852,25.1454468 L20.0639614,6.32722472 C20.0234302,5.93327333 19.6987925,5.63414003 19.3115157,5.63414003 L15.6803832,5.63414003 L15.6803832,4.78732302 C15.6803832,2.14768983 13.5807106,0 11.0000932,0 C8.41928202,0 6.31960936,2.14768983 6.31960936,4.78732302 L6.31960936,5.63414003 L2.68847695,5.63414003 C2.30120008,5.63414003 1.97656243,5.93327333 1.93603122,6.32722472 L0.00410741219,25.1454468 C-0.0181944809,25.3634491 0.0510383203,25.5810547 0.194352044,25.7441101 C0.337859783,25.9069672 0.542261252,26 0.756553128,26 L21.2432455,26 C21.4577314,26 21.6621328,25.9069672 21.8054466,25.7441101 C21.9491482,25.5810547 22.018187,25.3634491 21.9958852,25.1454468 Z M7.83264582,4.78732302 C7.83264582,3.00105284 9.25356589,1.54763791 11.0000932,1.54763791 C12.7464267,1.54763791 14.1673468,3.00105284 14.1673468,4.78732302 L14.1673468,5.63414003 L7.83264582,5.63414003 L7.83264582,4.78732302 Z M1.5966549,24.4523621 L3.3697506,7.18177794 L6.31960936,7.18177794 L6.31960936,8.88711545 C6.31960936,9.31439209 6.65840388,9.66093446 7.07612759,9.66093446 C7.4938513,9.66093446 7.83264582,9.31439209 7.83264582,8.88711545 L7.83264582,7.18177794 L14.1673468,7.18177794 L14.1673468,8.88711545 C14.1673468,9.31439209 14.5061413,9.66093446 14.923865,9.66093446 C15.3415887,9.66093446 15.6803832,9.31439209 15.6803832,8.88711545 L15.6803832,7.18177794 L18.630242,7.18177794 L20.4033377,24.4523621 L1.5966549,24.4523621 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#5FA800",
    cx: 24.5,
    cy: 9.5,
    r: 9.5
  }), /*#__PURE__*/React.createElement("text", {
    id: 5,
    fontFamily: "Helvetica",
    fontSize: 11,
    fontWeight: "normal",
    letterSpacing: -0.0130955,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 21,
    y: 11
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.3e2e0c6c.svg";
export { ForwardRef as ReactComponent };